import { UserRole } from "../enums/user-role";

export function getEnumUserRoleIndexByValue(value: string): number {
    return UserRole[value as keyof typeof UserRole];
}